import { useEffect } from 'react';
import { useFormikContext } from 'formik';

import { isMobile } from 'hooks';
import { formatPrice } from 'utils/helpers';
import { useCostQuery } from 'store/api/shipping-tier';
import {
  Row,
  Col,
  Info,
  Flex,
  Loader,
  InfoBlock,
  SwitchField,
} from 'components';

import * as Styles from './styles';
import { FormValues } from './types';

export const Package = () => {
  const mobile = isMobile();
  const { values, setFieldValue } = useFormikContext<FormValues>();
  const itemCount = values?.products?.reduce(
    (acc, product) => acc + +product.quantity,
    0
  );

  const { data, isLoading } = useCostQuery({ itemCount });

  useEffect(() => {
    setFieldValue('shippingPrice', Number(data?.price));
  }, [data?.price]);

  return (
    <Loader isLoading={isLoading}>
      <Styles.Container>
        <InfoBlock>
          <Row>
            <Col col={3} colTablet={4}>
              <Info value="USPS Large" title="Package Type" />
            </Col>

            <Col col={3} colTablet={4}>
              <Info value="12”" title="Package Type" />
            </Col>

            <Col col={3} colTablet={4}>
              <Info value="1/4”" title="Package Type" />
            </Col>

            <Col col={3} colTablet={4}>
              <Info value="6”" title="Package Type" />
            </Col>
          </Row>

          <Flex
            gap={24}
            column={mobile}
            alignItems={mobile ? undefined : 'center'}
            justifyContent={mobile ? undefined : 'flex-end'}
          >
            <Flex gap={8} alignItems="center">
              <h4>Price:</h4>
              <h2>{formatPrice(values.shippingPrice)}</h2>
            </Flex>

            <SwitchField name="isFreeShipping" label="Free Shipping" />
          </Flex>
        </InfoBlock>
      </Styles.Container>
    </Loader>
  );
};
